<script>
export default {
    layout: GuestLayout,
}</script>
<script setup>
import { ref } from "vue";
import { useForm } from "@inertiajs/inertia-vue3";
import { LockClosedIcon } from "@heroicons/vue/solid";
import GuestLayout from "@common/Layouts/Guest";

;

const props = defineProps({
    errors: {
        type: Object,
        required: false,
    },
});

const form = useForm({
    email: null,
    password: null,
    remember: false,
});

const login = () => {
    form.post(route("admin.sessions.store"));
};
</script>
<template>
    <div
        class="flex min-h-screen items-center justify-center px-4 sm:px-6 lg:px-8"
    >
        <div class="w-full max-w-md space-y-8">
            <div>
                <img
                    class="mx-auto w-auto"
                    src="https://digitalhq.com/images/logo/digitalhq.png"
                    alt="Workflow"
                />
                <h2
                    class="-mt-6 text-center text-3xl font-semibold text-gray-600"
                >
                    Sign in to your account
                </h2>
            </div>
            <form class="mt-8 space-y-6" action="#" @submit.prevent="login">
                <input type="hidden" name="remember" value="true" />
                <div class="-space-y-px rounded-md shadow-sm">
                    <div>
                        <label for="email" class="sr-only">Email address</label>
                        <input
                            id="email"
                            v-model="form.email"
                            name="email"
                            type="email"
                            autocomplete="email"
                            required="required"
                            class="relative block w-full appearance-none rounded-none rounded-t-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-sky-500 focus:outline-none focus:ring-sky-500 sm:text-sm"
                            placeholder="Email address"
                        />
                    </div>
                    <div>
                        <label for="password" class="sr-only">Password</label>
                        <input
                            id="password"
                            v-model="form.password"
                            name="password"
                            type="password"
                            autocomplete="current-password"
                            required="required"
                            class="relative block w-full appearance-none rounded-none rounded-b-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-sky-500 focus:outline-none focus:ring-sky-500 sm:text-sm"
                            placeholder="Password"
                        />
                    </div>
                </div>

                <div class="flex items-center justify-between">
                    <div class="flex items-center">
                        <input
                            id="remember"
                            v-model="form.remember"
                            name="remember"
                            type="checkbox"
                            class="h-4 w-4 rounded border-gray-300 text-sky-600 focus:ring-sky-500"
                        />
                        <label
                            for="remember"
                            class="ml-2 block text-sm text-gray-900"
                        >
                            Remember me
                        </label>
                    </div>
                </div>

                <div>
                    <button
                        type="submit"
                        :disabled="form.processing"
                        class="group relative flex w-full justify-center rounded-md border border-transparent bg-sky-600 py-2 px-4 text-sm font-medium text-white hover:bg-sky-700 focus:outline-none"
                    >
                        <span
                            class="absolute inset-y-0 left-0 flex items-center pl-3"
                        >
                            <LockClosedIcon
                                class="h-5 w-5 text-sky-500 group-hover:text-sky-400"
                                aria-hidden="true"
                            />
                        </span>
                        Sign in
                    </button>
                </div>
            </form>
            <div class="h-24">
                <div
                    v-if="Object.keys(props.errors).length"
                    class="animate-fade-in rounded border border-red-200 bg-red-50 py-2 text-center text-sm text-red-700"
                >
                    Unable to log you in with the provided credentials.
                </div>
            </div>
        </div>
    </div>
</template>
